import React from 'react'
import {
  TextField,
  Button,
  Box,
  Snackbar,
  ListItem,
  List,
  CircularProgress,
  Paper,
} from '@mui/material'
import MuiAlert from '@mui/material/Alert'
import { IIngredient, Ingredient } from 'interfaces/IIngredient'
import API from '@aws-amplify/api'
import { useDispatch } from 'react-redux'
import UnitsSelect from 'shared/autocomplete/unitsSelect'

export default function AddIngredient() {
  const [isSuccessSnackbarOpen, setIsSuccessSnackbarOpen] =
    React.useState(false)
  const [isFailureSnackbarOpen, setIsFailureSnackbarOpen] =
    React.useState(false)
  const [ingredientData, setIngredientData] = React.useState<IIngredient>(
    new Ingredient({})
  )
  const [isLoading, setIsLoading] = React.useState<any>(false)
  const [alertMessage, setAlertMessage] = React.useState('')

  const handleSnackbarClose = (): void => {
    setIsFailureSnackbarOpen(false)
    setIsSuccessSnackbarOpen(false)
  }

  const handleIngredientFieldChange = (value: any, key: string): void => {
    setIngredientData({ ...ingredientData, [key]: value })
  }

  const onFormSubmit = (e: React.SyntheticEvent): void => {
    e.preventDefault()
    setIsLoading(true)
    API.post('products', `/ingredients/createIngredient`, {
      body: { ...ingredientData },
    })
      .then((response) => {
        if (!response) {
          // failed to get data
        }
        setAlertMessage('Berhasil menambah bahan baku.')
        setIsSuccessSnackbarOpen(true)
        setIngredientData(new Ingredient({}))
      })
      .catch((error) => {
        let errorMessage = ''
        try {
          errorMessage = error.response.data.error
        } catch { }

        if (errorMessage === 'Ingredient name already exists') {
          setAlertMessage('Bahan baku sudah ada.')
        } else {
          setAlertMessage('Gagal menambah bahan baku.')
        }
        setIsFailureSnackbarOpen(true)
        // Error adding ingredient
      })
      .finally(() => {
        setIsLoading(false)
      })
  }

  const dispatch = useDispatch()
  React.useEffect(() => {
    dispatch({ type: 'SET_PAGE_TITLE', payload: 'Buat Bahan Baku' })
  }, [dispatch])

  return (
    <Box>
      <Paper>
        <form noValidate autoComplete="off" onSubmit={onFormSubmit}>
          <List>
            <ListItem>
              <TextField
                required
                autoComplete="off"
                variant="outlined"
                fullWidth
                label="Kode Bahan Baku"
                value={ingredientData.ingredientId}
                onChange={(e) =>
                  handleIngredientFieldChange(e.target.value, 'ingredientId')
                }
              />
            </ListItem>
            <ListItem>
              <TextField
                autoComplete="off"
                variant="outlined"
                fullWidth
                label="Nama Bahan Baku"
                value={ingredientData.ingredientName}
                onChange={(e) =>
                  handleIngredientFieldChange(e.target.value, 'ingredientName')
                }
              />
            </ListItem>
            <ListItem>
              <UnitsSelect
                value={ingredientData.unit || 'KG'}
                options={['KG', 'PCS']}
                onChange={(e) =>
                  handleIngredientFieldChange(e.target.value, 'unit')
                }
              />
            </ListItem>
            <ListItem>
              <TextField
                autoComplete="off"
                variant="outlined"
                fullWidth
                label="Stock"
                value={ingredientData.stock}
                type="number"
                onChange={(e) =>
                  handleIngredientFieldChange(e.target.value, 'stock')
                }
              />
            </ListItem>
            <ListItem>
              <Box mt={3}>
                <Button
                  variant="contained"
                  color="primary"
                  type="submit"
                  disabled={isLoading}
                >
                  Save
                </Button>
              </Box>
            </ListItem>
          </List>
          {isLoading && (
            <Box p={3}>
              <CircularProgress />
            </Box>
          )}
        </form>
      </Paper>
      <Snackbar
        open={isSuccessSnackbarOpen}
        autoHideDuration={6000}
        onClose={handleSnackbarClose}
      >
        <MuiAlert severity="success" elevation={6} variant="filled">
          {alertMessage}
        </MuiAlert>
      </Snackbar>
      <Snackbar
        open={isFailureSnackbarOpen}
        autoHideDuration={6000}
        onClose={handleSnackbarClose}
      >
        <MuiAlert severity="error" elevation={6} variant="filled">
          {alertMessage}
        </MuiAlert>
      </Snackbar>
    </Box>
  )
}
